import { bindActionCreators } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch } from 'react-redux';

import { trackDefaultEvent } from '../../actions/tracking';
import HeroShell from '../../components/hero/hero-shell';
import { getHeroSettings } from '../../helpers/hero';
import { heroEvents } from '../../shared/tracking';
import { H1 } from '../../styled-components/components/Heading';
import HeroComponent from '../../styled-components/components/Hero';
import { Label } from '../../styled-components/components/Label';
import { Stack, StackSmall } from '../../styled-components/components/Stack';
import MainSearch from '../../styled-components/structures/MainSearch';
import CtaButton from './CtaButton';

type HERO_EVENT_TYPES = keyof typeof heroEvents;

const Hero = () => {
  const dispatch = useDispatch();

  const actions = bindActionCreators({ trackDefaultEvent }, dispatch);

  const _heroSettings = getHeroSettings();

  const imageDesktop = _heroSettings?.imageDesktop;
  const imageMobile = _heroSettings?.imageMobile;
  const video = _heroSettings?.video;
  const heading = _heroSettings?.heading;
  const premable = _heroSettings?.premable;

  const callToActionTitle = _heroSettings?.callToActionTitle;
  const callToActionUrl = _heroSettings?.callToActionUrl;
  const callToActionTheme = _heroSettings?.callToActionTheme;

  const callToActionTitleSecondary = _heroSettings?.callToActionTitleSecondary;
  const callToActionUrlSecondary = _heroSettings?.callToActionUrlSecondary;
  const callToActionThemeSecondary = _heroSettings?.callToActionThemeSecondary;

  return (
    <>
      <HeroComponent
        image={{
          src: imageDesktop || '',
          srcLtSm: imageMobile || undefined,
          alt: heading,
        }}
        contentMaxWidth
        underHeader
      >
        <Stack>
          <StackSmall>
            <Label $tone="inverted" $faded>
              {heading}
            </Label>
          </StackSmall>
          <StackSmall>
            <H1 $noMargin>{premable}</H1>
          </StackSmall>
        </Stack>
        <Stack>
          <MainSearch />
        </Stack>
      </HeroComponent>

      {/* TOOD: Remove */}
      {false && (
        <HeroShell modifiers="" video={video} imageDesktop={imageDesktop} imageMobile={imageMobile}>
          <div className="hero-content-body">
            <div data-wx-label="light" className="m-b-half">
              {heading}
            </div>
            <h1 className="h1">{premable}</h1>
            <div className="m-t">
              <div className="btn-group">
                <CtaButton
                  callToActionTitle={callToActionTitle}
                  callToActionUrl={callToActionUrl}
                  ctaModifiers={callToActionTheme || 'action'}
                  eventType={heroEvents.HERO_LINK_CLICK as HERO_EVENT_TYPES}
                  trackDefaultEvent={actions.trackDefaultEvent}
                />
                <CtaButton
                  callToActionTitle={callToActionTitleSecondary}
                  callToActionUrl={callToActionUrlSecondary}
                  ctaModifiers={callToActionThemeSecondary || 'action-light'}
                  eventType={heroEvents.HERO_LINK_SECONDARY_CLICK as HERO_EVENT_TYPES}
                  trackDefaultEvent={actions.trackDefaultEvent}
                />
              </div>
            </div>
          </div>
        </HeroShell>
      )}
    </>
  );
};

export default Hero;
